import { Card } from "@mui/material"
import useCashSummary from "../portlibs/useCashSummary"
import PortUtils from "../portlibs/PortUtils"
import { OpenHistory } from "../dialogs/History"
import Holding from "../models/Holding"

function Summary(props:{title:string,value:number,currency:number,onClick?:()=>void}){
    return<Card className="card" onClick={props.onClick}>
        <h4>{props.title}</h4>
        <div>{PortUtils.formatCurrency(props.currency, props.value)}</div>
    </Card>
}
export default function CashSummary(){
    const {cash_ca_holding, cash_us_holding, cash_ca, cash_us, total_ca, total_us} = useCashSummary()
    const showHistory = OpenHistory()
    const onCash = (holding:Holding) => () => showHistory(holding)
    return <div className="cashSummary flex gap-16">
        <Summary title="CASH CA$" value={cash_ca} currency={0} onClick={onCash(cash_ca_holding)}/>
        <Summary title="CASH US$" value={cash_us} currency={1} onClick={onCash(cash_us_holding)}/>
    </div>
}